import { Grid } from '@mantine/core';
import { FC } from 'react';
import { NewsCard } from '@molecules/frontoffice/NewsCard';
import { SimpleGridNewsProps } from './types';

export const SimpleGridNews: FC<SimpleGridNewsProps> = ({ news }) => {
  return (
    <Grid columns={4} gutter="xs" gutterLg={40}>
      {news?.map((news) => (
        <Grid.Col span={4} md={2} lg={1} key={news.slug}>
          <NewsCard
            hasBadge
            news={news}
            titleOrder={1}
            titleVariant="h3Dark"
            hasSubtitle
            hasDescription={false}
          />
        </Grid.Col>
      ))}
    </Grid>
  );
};
